export enum HTTP_STATUS_CODE {
  // 2xx
  OK = 200,
  NO_CONTENT = 204,

  // 4xx
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  IM_A_TEAPOT = 418,

  // 5xx
  INTERNAL_SERVER_ERROR = 500
};



// WEBPACK FOOTER //
// /dist/src/app/shared/http-status-code.enum.ts